<template>
    <div>
        <div id="panel-4" class="panel">
            <div class="panel-hdr ">
                <h2>
                    {{ __t('LIST') }} <span class="fw-300"><i>{{__t('EMPLOYEES')}}</i></span>
                </h2>

                <div class="panel-toolbar">
                    <button class="btn btn-icon btn-sm btn-success mr-1 shadow-0 waves-effect waves-themed" v-on:click="create">
                        <i class="fal fa-plus"></i>
                    </button>

                    <button class="btn btn-panel waves-effect waves-themed"
                            data-action="panel-fullscreen"
                            data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen">
                    </button>
                </div>
            </div>

            <div class="panel-container show">
                <div class="panel-content">
                    <div class="filter_block mb-3">
                        <filter_employees></filter_employees>
                    </div>

                    <b-skeleton-table v-if="is_load" :rows=this.cur_records :columns="2" :hide-header=true :table-props="{ bordered: false, striped: true }"/>

                    <div class="inbox_vue_list" v-if="!is_load">

                        <div class="inb_pagi pt-4" v-if="rows.length > 0">
                            <pagination_list
                                key="up"
                                :total="pagination.total"
                                :limit="pagination.limit"
                                :current="pagination.pagesCurrent"
                                @page-change="handlePageChange">
                            </pagination_list>
                        </div>

                        <b-table
                            v-if="rows.length > 0"
                            :tbody-tr-class="rowClass"
                            striped class="table-responsive-xl resolution_table" :items="rows" :fields="fields">

                            <!-- header fields -->
                            <template v-slot:head(id)="data">
                                <div class="status_info" style="max-width: 50px">
                                    {{ __t('STATUS') }}
                                </div>
                            </template>

                            <template v-slot:head(uniq_id)="data">
                                <grid_list
                                    :list_ordering="'uniq_id'"
                                    :field_name="__t('UNIQ_ID')"
                                    :current_ordering="list.ordering"
                                    :current_direction="list.direction"
                                    @update-order="handleOrdering"
                                />
                            </template>

                            <template v-slot:head(displayName)="data">
                                <grid_list
                                    :list_ordering="'displayName'"
                                    :field_name="__t('TITLE')"
                                    :current_ordering="list.ordering"
                                    :current_direction="list.direction"
                                    @update-order="handleOrdering"
                                />
                            </template>

                            <template v-slot:head(short_code)="data">
                                <grid_list
                                    :list_ordering="'short_code'"
                                    :field_name="__t('SHORT_CODE')"
                                    :current_ordering="list.ordering"
                                    :current_direction="list.direction"
                                    @update-order="handleOrdering"
                                />
                            </template>

                            <template v-slot:head(created_at)="data">
                                {{__t('DATE')}}
                            </template>


                            <!-- body draw -->
                            <template  v-slot:cell(id)="data">
                                <div class="custom-control custom-checkbox">
                                    <input
                                        :disabled="true"
                                        :name="'cid[]'"
                                        v-model="data.item.is_upd"
                                        type="checkbox"
                                        class="custom-control-input"
                                        :id="data.item.id + '_cust_id'" />
                                    <label class="custom-control-label cursor-pointer bolder" :for="data.item.id + '_cust_id'"></label>
                                </div>
                            </template>


                            <template v-slot:cell(uniq_id)="data">
                                <div class="">
                                    <div class="d-flex flex-start w-100 fs-xl mb-2" >
                                        <div  class="icon-stack fs-xxl mr-2 cursor-pointer cursor-pointer" v-on:click="open_item(data.item)">
                                            <i class="base base-15 icon-stack-3x opacity-100 color-primary-900"></i>
                                            <i class="fal fa-indent icon-stack-1x opacity-100 color-white"></i>
                                        </div>
                                        {{data.item.uniq_id}}
                                    </div>

                                    <div class="d-flex flex-start w-100">
                                        <div class="small badge border border-success" v-if="data.item.hasOwnProperty('organization')">
                                            {{(data.item.organization || {}).provider}}
                                        </div>

                                        <div class="ml-3 small badge border border-warning" v-if="data.item.hasOwnProperty('organization')">
                                            {{(data.item.organization || {}).title}}
                                        </div>


                                    </div>
                                </div>
                            </template>

                            <template v-slot:cell(short_code)="data">
                                <div class="prod_name  fs-xl color-success-600">
                                    <span v-html=nice_search(data.item.short_code)></span>
                                </div>
                            </template>

                            <template v-slot:cell(displayName)="data">
                                <div class="prod_name  fs-xl color-success-600">
                                    <span v-html=nice_search(data.item.displayName)></span>
                                </div>
                            </template>


                        </b-table>


                        <div class="inb_pagi pt-4" v-if="rows.length > 0">
                            <pagination_list
                                key="down"
                                :total="pagination.total"
                                :limit="pagination.limit"
                                :current="pagination.pagesCurrent"
                                @page-change="handlePageChange">
                            </pagination_list>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <employ_modal></employ_modal>
    </div>
</template>

<script>

import {mapGetters} from "vuex";



import Grid_list from "../../../sys/list/grid_list.vue";
import Pagination_list from "../../../sys/list/pagination_list.vue";
import Filter_employees from "./filter_employees.vue";
import Employ_modal from "../modal/employ_modal.vue";



export default {
    name: "employees_list",
    components : {
        Employ_modal,
        Grid_list,
        Pagination_list,
        Filter_employees,
    },
    data() {
        return {
            rows: [],
            is_load: true,
            is_check_all: false,
            cur_records: 35,
            component_type: "employees",
            grid_trigger: "employ_inbox_change_state",

            list: {
                ordering: "id",
                direction: "DESC",
                start: 0,
                limit: 30
            },

            pagination: {
                total: 0,
                limit: 30,
                pagesCurrent: 1
            },

            filter: {
                search: "",
                provider_id: "",
                city_id: "",
                rest_group: ""
            },

            fields: [
                { key: 'id', label: '', class: 'text-center' },
                { key: 'uniq_id', label: '<i class="fal fa-cog width-2"></i>', class: '' },
                { key: 'displayName', label: 'e.displayName', class: '' },
                { key: 'short_code', label: 'e.short_code', class: '' },
                { key: 'phone', label: 'e.phone', class: '' },
                { key: 'created_at', label: 'e.created_at', class: '' },
            ]
        }
    },

    mounted() {
        this.load_items();
    },

    created() {
        EventBus.$on("search_empl_called",this.search_work);
        EventBus.$on("clean_empl_filter",this.clean_inbox_filter);
        EventBus.$on("org_filter_changed",this.filter_select);


        EventBus.$on("empl_reload_items",this.load_items);
        EventBus.$on(this.grid_trigger,this.change_state)

        EventBus.$on("reload_employees",this.load_items);

    },

    methods : {

        handleOrdering({ordering, direction}) {
            this.list.ordering = ordering;
            this.list.direction = direction;
            this.load_items();
        },

        handlePageChange({page, start}) {
            this.list.start = start;
            this.load_items();
        },

        search_work(search_str) {
            this.filter.search = search_str;
            this.list.start = 0;
            this.load_items();
        },

        filter_select(res) {
            this.filter[res.type] = res.value;
            this.list.start = 0;
            this.load_items();
        },

        clean_inbox_filter() {

            this.filter = {
                search: "",
                provider_id: "",
                city_id: "",
                rest_group: ""
            };

            this.list = {
                ordering: "id",
                direction: "DESC",
                start: 0,
                limit: 20
            };

            this.load_items();
        },

        async load_items() {
            this.rows = [];
            this.is_load = true;

            await api.post('/internal/v1/catalog/employees', {
                filter  : this.filter,
                list    : this.list
            })
                .then(({ data }) => {
                    this.is_load = false;
                    if (data.status === "operation_success") {
                        this.rows = data.data;

                        if (data.message?.pagination) {
                            this.pagination = data.message.pagination;
                        }
                    }
                })
                .catch(({ response }) => {
                    this.is_load = false;
                    this.rows = [];
                    EventBus.$emit('show_toast', {
                        err: response.data.message,
                        type: "danger",
                        title: response.data.status
                    });
                });
        },


        rowClass(item) {
            if (!item) return;
            return item.class;
        },

        open_item (item) {
            EventBus.$emit("employ_edit",parseInt(item.id));
        },

        create() {
            EventBus.$emit("employ_edit",0);
        },

        nice_search(str) {
            if (!this.filter.hasOwnProperty('search')) {
                return str;
            }
            return str.replace(new RegExp(this.filter.search, "i"), match => {
                return '<span class="text-danger">' + match + '</span>';
            });

        },
    },
    computed: {

        ...mapGetters({
            'user' : "user/getUser",
        }),
    }
}
</script>

<style scoped>
.table thead th:first-child {
    max-width: 20px;
}
</style>
